import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const voucherApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/vouchers/`, {params: params})
  },
  detail (voucherId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/vouchers/${voucherId}/`, {params: params})
  },
  update (voucherId, params) {
    return axios.put(
      `${ApiSetting.baseUrl}/api/vouchers/${voucherId}/`, querystring.stringify(params))
  }
}

export default voucherApi
